import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { User } from '@app/core/_models'
import { SelectedSession, SelectedSessionService } from '@app/core/_services'
import { EpochToTimePipe } from '@app/core/pipes/epoch-to-time.pipe'
import { SessionIndicatorIconsComponent } from '@app/routes/dashboard/components/session-indicator-icons/session-indicator-icons.component'
import { ButtonModule } from 'primeng/button'

@Component({
    selector: 'fm-selected-sessions-list-item',
    imports: [SessionIndicatorIconsComponent, EpochToTimePipe, ButtonModule],
    templateUrl: './selected-sessions-list-item.component.html',
    styleUrl: './selected-sessions-list-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedSessionsListItemComponent {
    @Input() sessionInfo: SelectedSession
    @Input() user: User

    public timeString: string
    public partnerNameOrStatusString: string
    public displayTimeFormat: string

    constructor(private selectedSessionService: SelectedSessionService) {}

    ngOnInit() {
        this.setTimeDisplayStringFormat()
    }
    ngOnChanges(e) {
        this.setTimeDisplayStringFormat()
    }

    private setTimeDisplayStringFormat(): void {
        const timeFormat = this.user.settings?.timeFormat ?? '12hr'
        if (timeFormat == '12hr') {
            this.displayTimeFormat = 'h:mma'
        } else {
            this.displayTimeFormat = 'HH:mm'
        }
    }

    onClickRemoveSession(): void {
        this.selectedSessionService.deleteSelectedSession(this.sessionInfo.sessionTime)
    }

    ngOnDestroy() {}
}
